"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AddVideoButton = _interopRequireDefault(require("./AddVideoButton"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var videoButtonBuilder = function videoButtonBuilder(useUnstyledButton, fileManagerUploadedFileAccess) {
  return function (_ref) {
    var onInsertVideo = _ref.onInsertVideo;
    return _react.default.createElement(_AddVideoButton.default, {
      fileManagerUploadedFileAccess: fileManagerUploadedFileAccess,
      onChange: onInsertVideo,
      useUnstyledButton: useUnstyledButton
    });
  };
};

videoButtonBuilder.propTypes = {
  onInsertVideo: _propTypes.default.func.isRequired
};
var _default = videoButtonBuilder;
exports.default = _default;
module.exports = exports.default;